import React from 'react';
import Hero from '../components/cee/Hero';
import Benefits from '../components/cee/Benefits';
import Process from '../components/cee/Process';
import Expertise from '../components/cee/Expertise';

const CEE = () => {
  return (
    <div className="pt-20">
      <Hero />
      <Benefits />
      <Process />
      <Expertise />
    </div>
  );
};

export default CEE;